export default __webpack_public_path__ + "static/anna-4c2efed67bbaea471c3438d70c54f414.webp";